
import React from "react";
import { css } from "aphrodite";
import { inject } from "mobx-react";
import { appStore } from "src/mobx/AppStore";
import { Application } from "src/core/application";
import {styles} from "./TableauFacultyPageStyle";
import {dashboard_base} from "./Setting";

interface IPageProps {
    history: any
}

const API_HOST ='https://localhost:8000';
//var _csrfToken =getCsrfToken();

export class TableauFacultyPage extends React.Component<IPageProps, {disable:boolean, awardData:any, proposalData:any}> {
   private ref: any;
   private outRef: any;
  private awardData: any;

  constructor (props: IPageProps) {
	super(props);
    this.ref =React.createRef();
    this.state ={disable: true, awardData: {}, proposalData: {}};
    this.getUnderlyingData =this.getUnderlyingData.bind(this);
	}

  public componentDidMount() {
  console.log('componentDidMount')
     console.log(this.state)
     console.log(this.awardData)
     if (typeof window.workbook !=='undefined') {
        this.switchToMapTab()
     }
     else {this.initViz();}
     }

  public switchToMapTab() {
     this.ref =window.ref;
     console.log(this.ref)
     window.workbook.activateSheetAsync("Faculty");
     window.activeSheet =window.workbook.getActiveSheet();
     }

  public initViz() {
     const host_url =dashboard_base + "Faculty";
     const options ={
                      hideToolbar: true,
                      device: "desktop",
                      hideTabs: true,
                      embed: "yes",
                      onFirstInteractive: () => {
                      this.setState((prevState) => ({ ...prevState, disable:false}));
                      console.log(this.state)
                      console.log("Run this code when the viz has finished loading.")
                      const workbook = Viz.getWorkbook();
                      const activeSheet = workbook.getActiveSheet();
                      window.workbook =workbook;
                      window.activeSheet =activeSheet;

                      }
                 }
     const Viz =new window.tableau.Viz(this.ref.current, host_url, options)
     }
 public getUnderlyingData() {

     const options ={       maxRows: 100,
                            ignoreAliases: false,
                            ignoreSelection: true,
                            includeAllColumns: false
                            };
     const sheetName =window.workbook.getActiveSheet().getName();
     console.log(sheetName)

     if (sheetName==="Curent_pending_dash") {
     const awardSheet  =window.workbook.getActiveSheet().getWorksheets().get("Current_awards");
     const proposalSheet  =window.workbook.getActiveSheet().getWorksheets().get("Pending_awards");
     const award =awardSheet.getSummaryDataAsync(options)
     .then( (table:any ) => {
                             this.setState(prevState => ({ ...prevState,
                             awardData: {awardDataValues: table.getData(), awardDataColumns: table.getColumns(),
                             awardRowCount: table.getTotalRowCount()}
                                                               }), () => {console.log('award');console.log(this.state);}
                                            )

                             }
            )
     //const awardPromise =Promise.resolve(award);
     const proposal =proposalSheet.getSummaryDataAsync(options)
                        .then( (table:any ) => {
                                                  this.setState(prevState => ({ ...prevState,
                                                  proposalData: {proposalDataValues: table.getData(), proposalDataColumns: table.getColumns(),
                                                  proposalRowCount: table.getTotalRowCount()}
                                                              }), () => {console.log('proposal');console.log(this.state); }
                                                                )
                                                }
                               )

     Promise.all([award, proposal])
     .then (() => {const requestOptions = {
                                                  method: 'POST',
                                                  headers: { },
                                                  mode: "cors" as RequestMode,
                                                  body: JSON.stringify({ awardData: this.state.awardData ,
                                                       proposalData: this.state.proposalData})
                                               };

                    fetch(`${API_HOST}/export/`, requestOptions)
                                          .then(
                                                res => res.blob(), res => {console.log('pdf fetch error'); console.log(res)})
                                                .then( (myBlob) => {const fileURL = window.URL.createObjectURL(myBlob);
                                                                    window.open(fileURL);
                                                                    }
                                                      )

                   }
            )





     }
  }

//<button className="facultyExport" style={{float: 'right'}} onClick={this.getUnderlyingData} disabled={this.state.disable}>PDF Export</button>
    public render() {
         return (
                <div className={css(styles.dashContainer)}>
                    <div className ="tableauPlaceholder" ref={this.ref}>




                    </div>
                    </div>



         );
    }
    }

export default TableauFacultyPage;



// WEBPACK FOOTER //
// ./src/pages/TableauFacultyPage.tsx